define('widgets/trophiesList/viewmodel',[
    'underscore',
    'knockout',
    'jquery'
], function(_, ko, $) {
    var trophyContainerDefaultHeight = 64;
    var ghostPadding = 70;

    var setupSelectionEvents = _.once(function() {
        $(document.body).on('click', function(e) {
            var $target = $(e.target).closest('.trophy-container.not-empty');

            $('.trophy-container').removeClass('selected');

            if ($target.length > 0) {
                $target.addClass('selected');

                calculateContainerHeight();
                scrollToTarget($target);
            } else {
                TrophiesList.selectedTrophy(undefined);
                resetContainerHeight();
            }
        });
    });

    var TrophiesList = function(getField, cmsGames) {
        var self = this;

        self.playButton = getField('play_button');

        self.getMobileProviderOrGameId = function(gamesArray) {
            // We expect by convention the last entry to be the mobile game id.
            return _.last(gamesArray);
        };

        self.getGame = function(trophy) {

            if (!trophy || _.isEmpty(trophy.providerGameIds())) {
                return;
            }

            var gameId = self.getMobileProviderOrGameId(trophy.providerGameIds());
            var game = cmsGames.mobileGames.getGameByProviderGameId(gameId)();

            // Return undefined for trophies without a mobile game
            if (game !== cmsGames.mobileGames.unknownGame) {
                return game;
            }
        };
    };

    TrophiesList.selectedTrophy = ko.observable();

    var resetContainerHeight = function() {
        $('.trophy-container').innerHeight(trophyContainerDefaultHeight);
    };

    var scrollToTarget = function($target) {
        $target = $target.find('.trophy-info-box');

        $('.pages').animate({
            scrollTop: $target.offset().top - $target.closest('.page').offset().top - 220
        }, 200);
    };

    var calculateContainerHeight = function() {
        // Pick actual elements
        var $selectedContainer = $('.trophy-container.selected');
        var $infoBox = $selectedContainer.find('.trophy-info-box');

        // Create ghost
        var $ghost = $infoBox.clone().addClass('ghost');
        $selectedContainer.append($ghost);

        // Set ghost width to parent width.
        $ghost.width($infoBox.width());

        // Get ghost height
        var ghostHeight = $ghost.innerHeight();

        $infoBox.innerHeight(ghostHeight);
        $selectedContainer.innerHeight(ghostHeight + ghostPadding);

        // Remove ghost
        $ghost.remove();

        // Reset not selected containers to default height.
        $('.trophy-container').not('.selected').innerHeight(trophyContainerDefaultHeight);
    };

    TrophiesList.prototype.activate = function(settings) {
        var self = this;

        self.trophies = ko.deferredComputed(function() {
            var mappedTrophies = _.map(settings.trophies(), function(trophy) {
                return _.isUndefined(trophy.achievement) ? trophy : trophy.achievement();
            });
            return settings.maxItems ? _.take(mappedTrophies, settings.maxItems) : mappedTrophies;
        });

        self.gridSize = ko.deferredComputed(function() {
            return settings.maxItems || (function() {
                var trophiesLength = self.trophies().length,
                    gridSize = settings.maxItems || trophiesLength,
                    x = 4;
                return Math.ceil(self.trophies().length / x) * x;
            })();
        });

        self.emptyBoxes = ko.deferredComputed(function() {
            var numberOfEmptyBoxes = self.gridSize() - self.trophies().length;
            if (numberOfEmptyBoxes < 0) {
                numberOfEmptyBoxes = 0;
            }
            return _.range(0, numberOfEmptyBoxes);
        });
    };

    TrophiesList.prototype.attached = function(view) {
        var self = this;

        setupSelectionEvents(self);
    };

    TrophiesList.prototype.selectTrophy = function(trophyId){
        TrophiesList.selectedTrophy(trophyId);
    };

    TrophiesList.prototype.isSelected = function(trophyId) {
        return trophyId === TrophiesList.selectedTrophy();
    };

    return TrophiesList;
});

